import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'

import { PdfThumbnailComponent } from './components'
import { PdfReaderComponent } from './components/pdf-reader/pdf-reader.component'
import { PdfTextLayerComponent } from './components/pdf-text-layer/pdf-text-layer.component'

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatTooltipModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  declarations: [
    PdfReaderComponent,
    PdfTextLayerComponent,
    PdfThumbnailComponent,
  ],
  exports: [
    PdfReaderComponent,
  ],
  providers: [],
})
export class PdfReaderModule { }
